var map = {
	"./Aggressive/occupations.json": [
		2980,
		980
	],
	"./Conservative/occupations.json": [
		1649,
		649
	],
	"./PulseCast/occupations.json": [
		6288,
		288
	],
	"./Realistic/occupations.json": [
		7322,
		322
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5399;
module.exports = webpackAsyncContext;